/**
 * Helper functions for generating Lexical rich text content for Payload CMS
 */

interface LexicalRoot {
  root: {
    type: string
    children: LexicalNode[]
    direction: 'ltr' | 'rtl' | null
    format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
    indent: number
    version: number
  }
  [key: string]: unknown
}

interface LexicalNode {
  type: string
  version: number
  [key: string]: unknown
}

/**
 * Creates a simple paragraph node
 */
export function createParagraph(text: string): LexicalNode {
  return {
    type: 'paragraph',
    children: [
      {
        type: 'text',
        detail: 0,
        format: 0,
        mode: 'normal',
        style: '',
        text,
        version: 1,
      },
    ],
    direction: 'ltr',
    format: '',
    indent: 0,
    textFormat: 0,
    version: 1,
  }
}

/**
 * Creates a complete Lexical rich text structure from an array of paragraphs
 */
export function createRichText(paragraphs: string[]): LexicalRoot {
  return {
    root: {
      type: 'root',
      children: paragraphs.map((p) => createParagraph(p)),
      direction: 'ltr',
      format: '',
      indent: 0,
      version: 1,
    },
  }
}
